import { render, staticRenderFns } from "./onsite.vue?vue&type=template&id=a5cb5208&scoped=true"
import script from "./onsite.vue?vue&type=script&lang=js"
export * from "./onsite.vue?vue&type=script&lang=js"
import style0 from "./onsite.vue?vue&type=style&index=0&id=a5cb5208&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5cb5208",
  null
  
)

export default component.exports